import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Eye, AlertCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DemoLoginPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [status, setStatus] = useState('loading'); // loading | error
  const [errorMsg, setErrorMsg] = useState('');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setErrorMsg('This demo link is missing its access token.');
      return;
    }
    const redeem = async () => {
      try {
        const res = await axios.post(`${API}/auth/demo-login`, { token });
        login(res.data.user, null, res.data.token);
        navigate('/curriculum', { replace: true });
      } catch (err) {
        setStatus('error');
        setErrorMsg(err.response?.data?.detail || 'This demo link could not be opened. Please request a new one.');
      }
    };
    redeem();
  }, [searchParams, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#34657f] to-[#3aa1c9] p-6" data-testid="demo-login-page">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-10 text-center">
        {status === 'loading' ? (
          <>
            <div className="w-14 h-14 rounded-2xl bg-amber-500/10 flex items-center justify-center mx-auto mb-5">
              <Eye className="w-7 h-7 text-amber-500" />
            </div>
            <div className="w-8 h-8 border-4 border-[#34657f] border-t-transparent rounded-full animate-spin mx-auto mb-5" />
            <h1 className="text-xl font-bold font-['Manrope'] text-[#1A1A1A] mb-2">Opening your demo preview…</h1>
            <p className="text-sm text-[#5C5C5C]">Setting up view-only access to Project LIFE.</p>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-5">
              <AlertCircle className="w-7 h-7 text-red-500" />
            </div>
            <h1 className="text-xl font-bold font-['Manrope'] text-[#1A1A1A] mb-2">Demo link unavailable</h1>
            <p className="text-sm text-[#5C5C5C] mb-6" data-testid="demo-login-error">{errorMsg}</p>
            <Button className="bg-[#34657f] hover:bg-[#2a5060]" onClick={() => navigate('/login')} data-testid="demo-login-go-login">
              Go to Login
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default DemoLoginPage;
